import React, { forwardRef, useImperativeHandle, useRef } from "react"
import ReactSelect from "react-select"
import AsyncSelect from "react-select/async"

import { farsiToEnglishDigitConverter } from "utils"
import classes from "./Select.module.scss"

const Select = (props, outerRef) => {
  const {
    error,
    label,
    className,
    placeholder,
    async = false,
    styles = {},
    loadOptions = () => { },
    noOptionsMessage,
    ...otherProps
  } = props

  const innerRef = useRef(null)

  useImperativeHandle(outerRef, () => innerRef.current, [])

  const handleLoadOptions = (inputValue, callback) => {
    const inputRef =
      innerRef.current.inputRef

    const start =
      inputRef.selectionStart

    const end =
      inputRef.selectionEnd

    const value =
      farsiToEnglishDigitConverter(inputValue)

    // preserve cursor position
    inputRef.setSelectionRange(start, end)

    loadOptions(value, callback)
  }

  const Component = async ? AsyncSelect : ReactSelect

  return (
    <div className={className}>
      {
        !!label &&
        <label className={classes["label"]}>
          {label}
        </label>
      }
      <Component
        ref={innerRef}
        loadOptions={handleLoadOptions}
        placeholder={placeholder}
        loadingMessage={() => "در حال بارگذاری"}
        noOptionsMessage={
          !!noOptionsMessage ? noOptionsMessage : () => "هیچ آپشنی یافت نشد"
        }
        styles={{
          option: (provided, state) => ({
            ...provided,
            cursor: "pointer",
            backgroundColor:
              state.isSelected ? "var(--color-primary)" : "inherit",
            "&:hover": {
              backgroundColor: state.isSelected
                ? "var(--color-primary)"
                : "var(--color-primary-alpha-25)"
            }
          }),
          loadingIndicator: (props) => ({
            ...props,
            direction: "ltr",
            transform: "scale(0.5)"
          }),
          dropdownIndicator: (props) => ({
            ...props,
            padding: "0px 8px"
          }),
          placeholder: (props) => ({
            ...props,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }),
          control: (props, state) => ({
            ...props,
            fontSize: "14px",
            minHeight: "33px",
            boxShadow:
              state.isFocused
                ?
                !!error
                  ? "0 0 0 0.2rem var(--color-danger-alpha-25)"
                  : "0 0 0 0.2rem var(--color-primary-alpha-25)"
                : ""
            ,
            borderColor:
              !!error
                ?
                "var(--color-danger)"
                :
                state.isFocused
                  ? "var(--color-primary)"
                  : "rgba(0,0,0,0.1)"
            ,
            borderWidth: "1px",
            "&:hover": {
              border:
                !!error
                  ? "1px solid var(--color-danger)"
                  : "1px solid rgba(0,0,0,0.1)"
            }
          }),
          ...styles
        }}
        {...otherProps}
      />
      {
        !!error &&
        <div className={classes["error"]}>
          {error}
        </div>
      }
    </div>
  )
}

export default forwardRef(Select)